import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import { Core } from "@faire/design-tokens";
import { READ_MORE } from "@faire/help-center/consts";
import { useSectionStore } from "@faire/help-center/hooks/useSectionStore";
import { NAVIGATION_FROM } from "@faire/help-center/views/eventEnum";
import articlePage from "@faire/web-api/routes/support/articles/articleId";
import { useStrictLocalization } from "@faire/web/common/localization";
import { Button } from "@faire/web/slate/Button";
import { Spacer } from "@faire/web/slate/spacing";
import { responsiveMediaQueries } from "@faire/web/slate/Theme/responsiveMediaQueries";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
import styled from "styled-components";
import { SectionHeader, SectionWrapper } from "./common";
export var SingleTopic = function SingleTopic(_ref) {
  var loadTimingRef = _ref.loadTimingRef;
  var _useStrictLocalizatio = useStrictLocalization(),
    strictLocalize = _useStrictLocalizatio.strictLocalize;
  var _useSectionStore = useSectionStore(),
    guides = _useSectionStore.aboutFaireSection,
    isLoading = _useSectionStore.isLoading;
  return /*#__PURE__*/React.createElement(SectionWrapper, {
    "$isLoading": isLoading,
    ref: loadTimingRef
  }, /*#__PURE__*/React.createElement(SectionHeader, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "2C+2Bm",
    defaultMessage: [{
      "type": 0,
      "value": "À propos de Faire"
    }]
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "3x"
  }), /*#__PURE__*/React.createElement(InnerWrapper, null, /*#__PURE__*/React.createElement(Section, null, guides.map(function (guide) {
    if (!guide.name) {
      return null;
    }
    return /*#__PURE__*/React.createElement(Tile, {
      key: guide.id
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "pageHeaderSerifRegular"
    }, guide.name), /*#__PURE__*/React.createElement(Spacer, {
      height: "1x"
    }), /*#__PURE__*/React.createElement(Typography, {
      color: Core.text.subdued,
      maxLines: 2
    }, guide.preview), /*#__PURE__*/React.createElement(Spacer, {
      height: "2x"
    }), /*#__PURE__*/React.createElement(Button, {
      variant: "tertiary",
      linkTo: {
        pathname: articlePage("".concat(guide.id)),
        state: {
          autoExpand: true,
          navigatedFrom: NAVIGATION_FROM.ABOUT_FAIRE,
          pageFrom: location.pathname,
          articleTitle: guide.name
        }
      }
    }, READ_MORE(strictLocalize)));
  }))));
};
var InnerWrapper = styled.div.withConfig({
  displayName: "SingleTopic__InnerWrapper"
})(["display:flex;flex-direction:column;", "{flex-direction:row;}"], responsiveMediaQueries.tabletAndAbove);
var Section = styled.div.withConfig({
  displayName: "SingleTopic__Section"
})(["display:flex;flex-wrap:wrap;", "{flex:2;}", "{&:last-child{flex:1;}}"], responsiveMediaQueries.tabletAndAbove, responsiveMediaQueries.desktopAndAbove);
var Tile = styled.div.withConfig({
  displayName: "SingleTopic__Tile"
})(["width:100%;padding-bottom:32px;", "{width:50%;padding-left:40px;padding-bottom:40px;}", "{width:33%;padding-left:56px;}"], responsiveMediaQueries.tabletAndAbove, responsiveMediaQueries.desktopAndAbove);